export type PromoPolicy = {
  showWaitScreen: boolean;
  allowExternal: boolean;
  allowInternalMori: boolean;
  allowPartnerDiscounts: boolean;
  kidsSafeOnly: boolean;
};

export function resolvePromoPolicy(args: {
  tier: 'seedling' | 'keeper' | 'storyteller';
  isChildCreator: boolean;
  isContributor: boolean;
}): PromoPolicy {
  const { tier, isChildCreator, isContributor } = args;

  if (isContributor) {
    return { showWaitScreen: true, allowExternal: false, allowInternalMori: true, allowPartnerDiscounts: false, kidsSafeOnly: false };
  }

  if (tier === 'keeper' || tier === 'storyteller') {
    return { showWaitScreen: false, allowExternal: false, allowInternalMori: false, allowPartnerDiscounts: false, kidsSafeOnly: false };
  }

  if (isChildCreator) {
    return { showWaitScreen: true, allowExternal: false, allowInternalMori: true, allowPartnerDiscounts: false, kidsSafeOnly: true };
  }

  return { showWaitScreen: true, allowExternal: true, allowInternalMori: true, allowPartnerDiscounts: false, kidsSafeOnly: false };
}
